import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dateConverter } from '../../../../helper/Helper';
import { get } from 'lodash'

class AboutProjectCard extends Component {
    constructor(props) {
        super(props)

        this.state = {

        }
    }

    formatDate = (date) => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    render() {
        const { snagDetail, tagCount, tagLimit } = this.props;
        // console.log(tagCount, tagLimit)
        const { phone, email, dateCreated, companyName, accessList } = snagDetail;
        const numberOfMember = accessList ? accessList.length : 0;

        const date = dateConverter(dateCreated);
        const listStyleText = { fontSize: "14px" };

        return (
            <div className="card p-2" style={{ borderRadius: '15px', overflow: 'auto' }}>
                <div className="card-header bg-white p-0 mx-2 mb-2">
                    <div className="row">
                        <div className="col-12">
                            <p style={{ textAlign: "start", fontWeight: "bold", fontSize: "18px" }}>Information</p>
                        </div>
                    </div>
                </div>
                <div className="card-body ">
                    <ul className="list-group list-group-flush" style={{ borderRadius: '20px' }}>
                        <li className="list-group-item py-2 d-flex align-items-start" ng-repeat="i in filters" style={listStyleText}><b className="mr-2">Company:</b> <p style={listStyleText}>{companyName}</p></li>
                        <li className="list-group-item py-2 d-flex align-items-start" ng-repeat="i in filters" style={listStyleText}><b className="mr-2">Phone:</b> <p style={listStyleText}>{phone}</p></li>
                        <li className="list-group-item py-2 d-flex align-items-start" ng-repeat="i in filters" style={listStyleText}><b className="mr-2">Email:</b> <p style={listStyleText}>{email}</p></li>
                        <li className="list-group-item py-2 d-flex align-items-start" ng-repeat="i in filters" style={listStyleText}><b className="mr-2">Members:</b> <p style={listStyleText}>{numberOfMember}</p></li>
                        <li className="list-group-item py-2 d-flex align-items-start" ng-repeat="i in filters" style={listStyleText}><b className="mr-2">Created on:</b><p style={listStyleText}>{date.parsedDate ? date.parsedDate : ''}</p></li>
                    </ul>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
    }
}

export default connect(mapStateToProps)(AboutProjectCard)
